module.exports = __webpack_public_path__ + "static/assets/cd77be4ebde61bded8556897c1f7e11f.png";